<template lang="pug">
  .conteudo
    .linha(style='margin: 0px')
      .coluna
        title-component(:label='$route.meta.titulo')

    .linha(style='margin-top: 0px')
      .coluna
        breadcrumb-component(:list="analiseProcesso")

    .linha(style='margin-top: 16px; justify-content: center;', v-if='isGerenteOperacional')
        .coluna(style='width: 100%;')
            .abas-container
                el-tabs(v-model='abaAtiva', @tab-click='onTabClick' class='custom-tabs')
                    el-tab-pane(label='Monitoramento dos PRADAS' name='monitoramentoEnviado')
                    el-tab-pane(label='Solicitações para envio do monitoramento' name='solicitacaoEnvio')
    FiltroComponent(
        ref='filtro'
        v-if='filtroCarregado'
        :municipios='municipiosFiltrados'
        :regionais='regionaisFiltradas'
        :abaAtiva='abaAtiva'
        @filtro:pesquisar='filtro => pesquisar(filtro, true)'
        @filtro:limpar='limpar'
        @regional:alterada='buscarMunicipiosDisponiveis'
        @municipio:alterado='buscarRegionaisDisponiveis'
        @mostrar-exportar="mostrarBotaoExportar = $event"
        :labelCampoData='isMonitoramentoEnviado ? "do envio do monitoramento" : "da solicitação"'
    )


    .linha(style='padding-top: 20px', v-if='isMonitoramentoEnviado')
      b.coluna Listagem de monitoramento do PRADA
      button.btn-monitoramento(
        :disabled="isReciboButtonDisabled"
        :class="{ 'btn-desabilitado': isReciboButtonDisabled }"
        @click="baixarRecibosSelecionados"
        :title="isReciboButtonDisabled ? 'Selecione monitoramentos finalizados para baixar os recibos' : 'Baixar recibos dos monitoramentos selecionados'"
      ) Recibo do monitoramento

      button.btn-relatorio(
        :disabled="isExportButtonDisabled"
        :class="{ 'btn-desabilitado': isExportButtonDisabled }"
        @click="abrirModalRelatorio = true"
      ) Exportar relatório

    .linha
      .coluna(v-loading="isDownloadingRecibo")
        monitoramento-table-component(
          v-if='isMonitoramentoEnviado'
          ref='monitoramentoEnviado'
          :is-loading='isLoading'
          :selecionados="selecionados"
          :is-gerente-operacional="isGerenteOperacional"
          :is-tecnico="isTecnico"
          @update-selecionados="selecionados= $event"
          @inbox:page-change='checkPaginationChange($event)'
          @inbox:items-per-page-change='onItemsPerPageChange($event)'
          @inbox:pagination='getPagination($event)'
          @abrir-monitoramento='abrirModalDeMonitoramento'
          @gerar-recibo='baixarRecibo'
          @abrir-ficha="abrirFichaImovel"
          @validar-monitoramento='abrirModalValidacao'
          @enviar-notificacao='abrirModalNotificacao'
        )
        solicitacao-table-component(
          v-else
          ref='solicitacaoEnvio'
          @inbox:page-change='checkPaginationChange($event)'
          @inbox:items-per-page-change='onItemsPerPageChange($event)'
        )


    ModalValidacaoMonitoramentoComponent(
      v-if='showModalValidacao'
      :monitoramento='monitoramentoParaValidar'
      :read-only='!isGerenteOperacional'
      @close='showModalValidacao = false'
      @finalizado='onValidacaoFinalizada'
    )

    ModalComponent(
      v-if='abrirModalDetalhesParcela'
      :title='monitoramentoSelecionado.numeroDoCAR'
      width='900px'
      @close='fecharModalDetalhesParcela'
    )
      DetalhesMonitoramento(:monitoramento='monitoramentoSelecionado')
      .modal-content
        Mapa(
          ref='mapa'
          :area='monitoramentoSelecionado.nomeArea'
          :codigoImovel='monitoramentoSelecionado.numeroDoCAR'
        )

        .listagem-fotos-scroll
          table
            thead
              tr
                th
                th
            tbody
              tr(
                v-for="(parcela, pIndex) in monitoramentoSelecionado.etapasFotoParcela"
                :key="parcela.id"
              )
                td.titulo-arquivo-foto(v-if="pIndex === 0" :rowspan="monitoramentoSelecionado.etapasFotoParcela.length")
                  b Arquivo da foto:
                td.descricao-foto
                  div(v-for="(anexo, index) in parcela.anexos" :key="index")
                    | Visada {{ anexo.visada }} {{ anexo.dataFoto | data }}
                    button(type="button" class="botao-acoes" title="Baixar foto" @click="baixarFoto(anexo.id)")
                      i(class="el-icon-download")
                    .foto-preview(v-if="fotoUrls[anexo.id]")
                      img(:src="fotoUrls[anexo.id]" alt="Foto da parcela" class="foto-parcela")
                    .foto-preview-loading(v-else-if="fotoCarregando[anexo.id]")
                      i(class="el-icon-loading") Carregando...

              tr
                td.titulo-arquivo-foto
                  b Arquivo vetorial
                td.descricao-foto
                  | {{monitoramentoSelecionado.nomeArea}} KML
                  button(
                    type="button"
                    class="botao-acoes"
                    title="Baixar arquivo KML"
                    @click="baixarArquivoKML(monitoramentoSelecionado)"
                  )
                    i(class="el-icon-download")

        BotaoComponent(
          style="display: flex; justify-content: flex-end;"
          :tipo="'limpar'"
          :titulo="'Cancelar'"
          icone='el-icon-close'
          :acao="fecharDetalhesParcela"
        )

    ModalComponent(
      v-if="abrirModalRelatorio"
      :title="'Relatório de Monitoramento'"
      width="900px"
      @close="fecharModalRelatorio"
    )
      .modal-body-scroll
        div(
                    v-for="(item, index) in selecionadosParaAcao"
          :key="item.id"
          class="bloco-processo"
        )
          p
            b CAR:
            |  {{ item.numeroDoCAR }}

          p
            b Município:
            |  {{ item.municipio }}

          p
            b Envio do monitoramento:
            |  {{ item.envioDataMonitoramento }}

          p
            b Nome da Área:
            |  {{ item.nomeArea }}

          p
            b Área a recompor (ha):
            |  {{ item.areaRecompor }}

          p
            b Status do monitoramento:
            |  {{ formatarStatus(item.statusMonitoramento) }}

          p
            b Status da validação:
            |  {{ formatarStatusValidacao(item.statusValidacao) }}

          p
            b Avaliação Geral:
            |  {{ item.avaliacaoGeral }}

          p
            b Fases do Processo:
            |  {{ item.faseProcesso }}

          p(v-if="item.dominio && item.dominio.length" style="white-space: pre-line")
            b Domínios do imóvel:
            br
            span {{ formatarDominiosTexto(item.dominio) }}

          p
            b Tempo de recomposição:
            |  {{ item.tempoRecomposicao }}

          p
            b Nível de adequação:
            |  {{ item.nivelAdequado }}

          button.btn-download-individual(@click="baixarRelatorio(item)")
             i.el-icon-download
             |  Baixar este processo

      .footer-download
        button.btn-download-todos(@click="baixarTodosRelatorios")
           i.el-icon-download
           |  Baixar todos os processos

      BotaoComponent(
        style="display: flex; justify-content: flex-end; margin-top: 20px"
        :tipo="'limpar'"
        :titulo="'Fechar'"
        icone='el-icon-close'
        :acao="fecharModalRelatorio"
      )


    ModalComponent(
        v-if="showModalNotificacao"
        :title="tituloModalNotificacao"
        width="500px"
        @close="fecharModalNotificacao"
        )
        .modal-notificacao-body
            .alerta-info
                i.el-icon-warning-outline.alerta-icon
                span.alerta-texto
                    | Esta ação enviará uma
                    b mensagem de notificação
                    |  à Central do Proprietário/Possuidor informando que o monitoramento encontra-se vencido, para que o responsável tome ciência da situação e adote as providências cabíveis.

            .campo-ultima-notificacao()
                            .info-ultima-notificacao
                                span.label-ultima-notificacao Última notificação gerada:
                                span.data-ultima-notificacao {{ monitoramentoParaNotificar.dataEnvioNotificacao.split(' ')[0]}}

                            button.btn-download-pdf-notificacao(
                                type="button"
                                :disabled="baixandoPdfNotificacao"
                                :class="{ 'btn-desabilitado': baixandoPdfNotificacao }"
                                @click="baixarPdfNotificacao"
                            )
                                i(:class="baixandoPdfNotificacao ? 'el-icon-loading' : 'el-icon-download'")
                                |  {{ baixandoPdfNotificacao ? 'Baixando...' : 'Baixar PDF da notificação' }}

            .footer-notificacao
                BotaoComponent(
                    :tipo="'limpar'"
                    :titulo="'Cancelar'"
                    icone='el-icon-close'
                    :acao="fecharModalNotificacao"
                )
                BotaoComponent(
                    :tipo="'primario'"
                    :titulo="'Enviar Notificação'"
                    icone='el-icon-message'
                    :acao="confirmarEnvioNotificacao"
                    :loading="enviandoNotificacao"
                )

</template>

<script>
import MonitoramentoTableComponent from '@/views/monitoramento/components/MonitoramentoTable.vue';
import SolicitacaoTableComponent from './components/SolicitacaoTable.vue';
import ModalValidacaoMonitoramentoComponent from '@/views/monitoramento/components/ModalValidacaoMonitoramento.vue';
import {
    downloadRecibo,
    obterReciboBlob,
    downloadRelatorioMonitoramentos,
    downloadArquivoFotoParcelasV2,
    buscarSalvoPorIdMonitoramento,
    buscarArquivoKML,
    enviarNotificacao,
    baixarPdfNotificacaoVencida
} from '@/services/monitoramento.service';
import {
    listarMunicipios,
    obterRegionais
} from '@/services/regiao.service';
import { analiseProcesso } from '@/utils/breadcrumb.utils';
import FiltroComponent from '@/views/monitoramento/components/FiltroComponent.vue';
import MonitoramentoModal from '@/views/monitoramento/components/MonitoramentoModal.vue';
import Mapa from '@/components/Mapa/Mapa.vue';
import BotaoComponent from '@/components/design/BotaoComponent.vue';
import ModalComponent from '@/components/design/ModalComponent.vue';
import CheckboxInputComponent from '@/components/design/CheckboxInputComponent.vue';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { buscarUrlAcessoFichaImovel } from '@/services/ficha-imovel.service';
import DetalhesMonitoramento from '@/views/monitoramento/components/DetalhesMonitoramento.vue';
import { Perfil } from '@/utils/constants.utils.js';

export default {
    name: 'MonitoramentoPrada',
    components: {
        MonitoramentoTableComponent,
        SolicitacaoTableComponent,
        FiltroComponent,
        ModalValidacaoMonitoramentoComponent,
        MonitoramentoModal,
        Mapa,
        BotaoComponent,
        ModalComponent,
        CheckboxInputComponent,
        DetalhesMonitoramento,
    },
    filters: {
        formatarCpfCnpj(valor, tipo) {
            if (!valor) return '';
            const digits = valor.replace(/\D/g, '');
            if (tipo === 'PF' && digits.length === 11) {
                return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (tipo === 'PJ' && digits.length === 14) {
                return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
            return valor;
        },
    },
    data() {
        return {
            analiseProcesso,
            filtroCarregado: false,
            isLoading: false,
            isDownloadingRecibo: false,
            selecionados: [],
            itemSelecionado: { id: 1, nome: 'Mapa de Parcelas' },
            statusLabels: {
                AGUARDANDO_MONITORAMENTO: 'Aguardando Monitoramento',
                PENDENTE_DE_ENVIO: 'Pendente de Envio',
                FINALIZADO: 'Finalizado',
            },

            filtro: {},
            municipiosAll: [],
            regionaisAll: [],
            municipiosFiltrados: [],
            regionaisFiltradas: [],
            abrirModalDetalhesParcela: false,
            modalTitulo: 'Monitoramento Enviado',
            monitoramentoSelecionado: null,
            mostrarBotaoExportar: false,
            abrirModalRelatorio: false,
            abaAtiva: 'monitoramentoEnviado',
            isGerenteOperacional: false,
            isTecnico: false,
            fotoUrls: {},
            fotoCarregando: {},
            showModalValidacao: false,
            monitoramentoParaValidar: null,
            showModalNotificacao: false,
            monitoramentoParaNotificar: null,
            enviandoNotificacao: false,
            baixandoPdfNotificacao: false,
        };
    },
    computed: {
        selecionadosParaAcao() {
            const mapa = new Map();

            this.selecionados.forEach((item) => {
                if (item?.idMonitoramento) {
                    mapa.set(item.idMonitoramento, item);
                }
            });

            return Array.from(mapa.values());
        },
        isExportButtonDisabled() {
            return this.selecionadosParaAcao.length === 0;
        },
        isReciboButtonDisabled() {
            return this.selecionadosParaAcao.length === 0 || this.selecionadosParaAcao.some(item => item.statusMonitoramento !== 'FINALIZADO');
        },
        isMonitoramentoEnviado() {
            return this.abaAtiva === 'monitoramentoEnviado';
        },
        tituloModalNotificacao() {
            return `Envio de Notificação - Monitoramento Vencido\n${this.monitoramentoParaNotificar?.numeroDoCAR || ''}`;
        },
    },
    async created() {
        const usuario = this.$eu();
        this.isGerenteOperacional = usuario.perfil === Perfil.GERENTE_OPERACIONAL;
        this.isTecnico = usuario.perfil === Perfil.TECNICO;

        try {
            const [municipiosAll, regionaisAll] = await Promise.all([
                listarMunicipios(),
                obterRegionais(),
            ]);

            this.municipiosAll = Array.isArray(municipiosAll) ? municipiosAll : [];
            this.regionaisAll = Array.isArray(regionaisAll) ? regionaisAll : [];

            this.municipiosFiltrados = [...this.municipiosAll];
            this.regionaisFiltradas = [...this.regionaisAll];
        } catch (error) {
            this.municipiosAll = [];
            this.regionaisAll = [];
            this.$message.error('Erro ao carregar os filtros de monitoramento.');
        } finally {
            this.filtroCarregado = true;
        }
    },
    methods: {
        onTabClick() {

            this.$nextTick(() => {
                if (this.$refs.filtro && typeof this.$refs.filtro.limpar === 'function') {
                    this.$refs.filtro.limpar();
                }
            });
        },
        pesquisar(filtro = {}, resetarSelecao = false) {
            this.isLoading = true;
            this.filtro = filtro;

            if (resetarSelecao) {
                this.selecionados = [];
            }

            const abaRef = this.$refs[this.abaAtiva];
            if (abaRef && typeof abaRef.pesquisar === 'function') {
                abaRef.pesquisar(filtro);
            }

            this.isLoading = false;
        },
        abrirModalValidacao(item) {
            this.monitoramentoParaValidar = item;
            this.showModalValidacao = true;
        },
        async onValidacaoFinalizada() {
            this.showModalValidacao = false;
            const abaRef = this.$refs.monitoramentoEnviado;
            if (abaRef && typeof abaRef.refreshHistoricoCache === 'function') {
                await abaRef.refreshHistoricoCache(this.monitoramentoParaValidar);
            }
            this.pesquisar(this.filtro);
        },
        abrirFichaImovel(processo) {
            buscarUrlAcessoFichaImovel(processo.idProcesso)
                .then((url) => {
                    window.open(url, '_blank');
                })
                .catch(() => {
                    this.$toast({
                        message: 'Erro ao abrir ficha do imóvel.',
                        type: 'error',
                        showClose: true,
                    });
                });
        },
        formatarStatus(status) {
            return this.statusLabels[status] || 'Status desconhecido';
        },
        formatarStatusValidacao(statusValidacao) {
            if (statusValidacao === null) {
                return 'AGUARDANDO MONITORAMENTO';
            }

            return statusValidacao === 'PENDENTE_VALIDACAO' ? 'PENDENTE DE VALIDAÇÃO' : statusValidacao;
        },
        formatarNome(nome) {
            if (!nome) return '';
            return nome
                .toLowerCase()
                .split(' ')
                .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
                .join(' ');
        },
        atualizarSelecionados(novaLista) {
            this.selecionados = novaLista;
        },
        abrirModalDeMonitoramento(item) {
            this.monitoramentoSelecionado = item;
            this.abrirModalDetalhesParcela = true;
            this.loadSavedData(item);
            this.carregarFotos(item);
        },
        loadSavedData(monitoramento) {
            buscarSalvoPorIdMonitoramento(monitoramento.idMonitoramento, monitoramento.numeroDoCAR)
                .then((response) => {
                    const parcelas = response.parcelas;

                    Object.keys(parcelas).forEach((key) => {
                        const item = parcelas[key];

                        if (
                            item.coordenadas &&
                            item.coordenadas.coordinates &&
                            Array.isArray(item.coordenadas.coordinates[0])
                        ) {
                            const coordenadasCorrigidas = item.coordenadas.coordinates[0].map((coord) => [
                                coord[1],
                                coord[0],
                            ]);

                            if (coordenadasCorrigidas && coordenadasCorrigidas.length > 0) {
                                setTimeout(() => {
                                    this.desenharPoligonoExistente({
                                        geometry: { coordinates: [coordenadasCorrigidas] },
                                        centro: [item.centro[1], item.centro[0]],
                                    });
                                }, 2000);
                            } else {
                                console.error('Coordenadas corrigidas não são válidas:', coordenadasCorrigidas);
                            }
                        }
                    });
                })
                .catch((err) => {
                    console.error('Erro ao carregar dados salvos:', err);
                });
        },
        desenharPoligonoExistente({ geometry, centro }) {
            this.podeDesenhar = false;

            if (!geometry || !geometry.coordinates || !centro) {
                console.error('Geometria ou centro inválidos para desenhar o polígono:', { geometry, centro });
                return;
            }

            let coordenadasValidadas = this.validarCoordenadasPolygon(geometry.coordinates[0]);

            if (!coordenadasValidadas || coordenadasValidadas.length < 3) {
                console.error('Coordenadas do polígono inválidas:', geometry.coordinates[0]);
                return;
            }

            const latLngs = coordenadasValidadas.map((coord) => [coord[1], coord[0]]);
            const centroCorrigido = [centro[1], centro[0]];

            this.$refs.mapa.desenharPoligonoFixado(latLngs, centroCorrigido);
        },
        validarCoordenadasPolygon(coordenadas) {
            if (Array.isArray(coordenadas) && coordenadas.length > 0) {
                const coordenadasValidas = coordenadas
                    .map((coord) => {
                        if (Array.isArray(coord) && coord.length === 2 && !isNaN(coord[0]) && !isNaN(coord[1])) {
                            return coord;
                        } else {
                            console.error('Coordenada inválida:', coord);
                            return null;
                        }
                    })
                    .filter((coord) => coord !== null);

                return coordenadasValidas.length === coordenadas.length ? coordenadasValidas : null;
            }
            return null;
        },
        fecharModalDetalhesParcela() {
            this.abrirModalDetalhesParcela = false;
            this.revogarFotoUrls();
        },
        baixarArquivoKML(monitoramento) {
            const codImovel = monitoramento.numeroDoCAR;
            const etapas = monitoramento.etapasFotoParcela || [];

            const zip = new JSZip();

            const promises = etapas.map((etapa, index) => {
                const idArquivo = Array.isArray(etapa.anexos) ? etapa.anexos[0]?.id : undefined;

                if (!idArquivo) {
                    console.warn(`Etapa ${index + 1} ignorada (anexos.id ausente ou inválido).`);
                    return Promise.resolve(); // Ignora etapas sem anexo válido
                }

                return buscarArquivoKML(idArquivo, codImovel)
                    .then((resposta) => {
                        const blob = new Blob([resposta.data], {
                            type: 'application/vnd.google-earth.kml+xml',
                        });

                        // Tenta extrair o nome do arquivo do header
                        const contentDisposition = resposta?.request?.getResponseHeader('Content-Disposition');
                        let filename = `Parcela_${index + 1}.kml`;

                        if (contentDisposition) {
                            const match = contentDisposition.match(/filename="(.+?)"/);
                            if (match && match[1]) {
                                filename = match[1];
                            }
                        }

                        zip.file(filename, blob);
                    })
                    .catch((error) => {
                        console.error(`Erro ao baixar etapa ${index + 1} (id ${idArquivo}):`, error);
                    });
            });

            Promise.all(promises)
                .then(() => {
                    zip.generateAsync({ type: 'blob' })
                        .then((zipBlob) => {
                            FileSaver.saveAs(zipBlob, `parcelas_${codImovel}.zip`);
                        })
                        .catch((err) => {
                            console.error('Erro ao gerar o ZIP:', err);
                        });
                })
                .catch((error) => {
                    this.$toast({
                        showClose: true,
                        message: 'Erro ao processar os arquivos KML.',
                        type: 'error',
                    });
                    console.error('Erro ao processar os arquivos:', error);
                });
        },
        baixarFoto(idFoto) {
            downloadArquivoFotoParcelasV2(idFoto, this.monitoramentoSelecionado.numeroDoCAR)
                .then((response) => {
                    const contentType = response.headers['content-type'];
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = `foto-${idFoto}.png`;

                    if (contentDisposition && contentDisposition.includes('filename=')) {
                        const match = contentDisposition.match(/filename="(.+?)"/);
                        if (match && match[1]) {
                            filename = match[1];
                        }
                    }

                    const blob = response.data instanceof Blob
                        ? response.data
                        : new Blob([response.data], { type: contentType });

                    FileSaver.saveAs(blob, filename);
                })
                .catch((error) => {
                    console.error('Erro no download:', error);
                    this.$toast({
                        showClose: true,
                        message: 'Falha no download da foto solicitada.',
                        type: 'error',
                    });
                });
        },
        carregarFotos(monitoramento) {
            const codigoImovel = monitoramento.numeroDoCAR;
            const etapas = monitoramento.etapasFotoParcela || [];
            etapas.forEach((parcela) => {
                const anexos = Array.isArray(parcela.anexos) ? parcela.anexos : [];
                anexos.forEach((anexo) => {
                    if (!anexo.id || this.fotoUrls[anexo.id] !== undefined) return;
                    this.$set(this.fotoCarregando, anexo.id, true);
                    downloadArquivoFotoParcelasV2(anexo.id, codigoImovel)
                        .then((response) => {
                            const contentType = response.headers['content-type'] || 'image/jpeg';
                            const blob = response.data instanceof Blob
                                ? response.data
                                : new Blob([response.data], { type: contentType });
                            const url = URL.createObjectURL(blob);
                            this.$set(this.fotoUrls, anexo.id, url);
                        })
                        .catch((error) => {
                            console.error(`Erro ao carregar foto ${anexo.id}:`, error);
                            this.$set(this.fotoUrls, anexo.id, null);
                        })
                        .finally(() => {
                            this.$set(this.fotoCarregando, anexo.id, false);
                        });
                });
            });
        },
        revogarFotoUrls() {
            Object.values(this.fotoUrls).forEach((url) => {
                if (url) URL.revokeObjectURL(url);
            });
            this.fotoUrls = {};
            this.fotoCarregando = {};
        },

        checkPaginationChange(page) {
            this.pesquisar({
                ...this.filtro,
                pagina: page,
            }, true);
        },
        onItemsPerPageChange(itemsPerPage) {
            const abaRef = this.$refs[this.abaAtiva];
            const dadosAtuais = abaRef?.paginacao?.processos || [];

            if (this.selecionados.length > 0 && dadosAtuais.length > 0) {
                this.selecionados = this.selecionados.filter(itemSelecionado => {
                    const indice = dadosAtuais.findIndex(item =>
                        item === itemSelecionado ||
                        (item.numeroDoCAR && item.numeroDoCAR === itemSelecionado.numeroDoCAR &&
                         item.nomeArea === itemSelecionado.nomeArea)
                    );
                    return indice !== -1 && indice < itemsPerPage;
                });
            }

            this.pesquisar({
                ...this.filtro,
                tamanho: itemsPerPage,
                pagina: 1,
            }, false);
        },
        getPagination(paginationEvent) {
            return paginationEvent;
        },
        async baixarRecibo(item) {
            this.isDownloadingRecibo = true; // início do loading

            try {
                await downloadRecibo(item.idMonitoramento);
            } catch (error) {
                console.error('Erro ao baixar recibo:', error);
                this.$message.error('Erro ao baixar o recibo.');
            } finally {
                this.isDownloadingRecibo = false; // fim do loading
            }
        },

        limpar(filtroLimpo = {}) {
            this.municipiosFiltrados = [...this.municipiosAll];
            this.regionaisFiltradas = [...this.regionaisAll];
            this.filtro = filtroLimpo;
        },
        fecharDetalhesParcela() {
            this.abrirModalDetalhesParcela = false;
            this.revogarFotoUrls();
        },
        fecharModalRelatorio() {
            this.abrirModalRelatorio = false;
        },
        async desenharPoligonos() {
            await this.$nextTick();
            setTimeout(() => {
                this._desenharPoligonosInterno();
            }, 200);
        },
        async _desenharPoligonosInterno() {
            const monitoramento = this.monitoramentoSelecionado;
            const mapaRef = this.$refs.mapa;
            await this.$nextTick();

            if (!monitoramento || !mapaRef) {
                console.warn('⚠️ Monitoramento ou referência do mapa está ausente');
                return;
            }

            const etapas = Array.isArray(monitoramento.etapasFotoParcela) ? monitoramento.etapasFotoParcela : [];

            etapas.forEach((parcela) => {
                const anexos = Array.isArray(parcela.anexos) ? parcela.anexos : [];

                anexos.forEach((anexo) => {
                    const geometry = anexo.coordenadas;
                    const centro = anexo.geolocalizacao;

                    if (geometry?.coordinates && centro?.latitude && centro?.longitude) {
                        const coordenadas = geometry.coordinates[0];

                        const validas = coordenadas
                            .map((coord) =>
                                Array.isArray(coord) && coord.length === 2 && !isNaN(coord[0]) && !isNaN(coord[1])
                                    ? coord
                                    : null
                            )
                            .filter((coord) => coord !== null);

                        if (validas.length >= 3) {
                            const latLngs = validas.map(([lng, lat]) => [lat, lng]);
                            const centroCorrigido = [centro.latitude, centro.longitude];

                            mapaRef.desenharPoligonoFixado(latLngs, centroCorrigido);
                        } else {
                            console.warn('❌ Polígono inválido: menos de 3 coordenadas ou inválidas', coordenadas);
                        }
                    } else {
                        console.warn('❌ Anexo com dados ausentes:', anexo);
                    }
                });
            });
        },
        async baixarRecibosSelecionados() {
            if (this.selecionadosParaAcao.length === 0) return;

            const invalido = this.selecionadosParaAcao.find((item) => item.faseProcesso !== 'RESUMO');
            if (invalido) {
                this.$message.error('⚠️ Um ou mais processos não estão na fase "RESUMO". Corrija para continuar.');
                return;
            }

            const zip = new JSZip();
            const pasta = zip.folder('recibos-monitoramento');
            const erros = [];

            for (const item of this.selecionadosParaAcao) {
                try {
                    const blob = await obterReciboBlob(item.idMonitoramento);
                    const nomeArquivo = `recibo_${item.numeroDoCAR || item.id}.pdf`;
                    pasta.file(nomeArquivo, blob);
                } catch (error) {
                    console.error('Erro ao obter recibo:', error);
                    erros.push(item.numeroDoCAR || item.id);
                }
            }

            if (erros.length) {
                this.$message.warning(`⚠️ Recibos com erro: ${erros.join(', ')}`);
            }

            const conteudoZip = await zip.generateAsync({ type: 'blob' });
            saveAs(conteudoZip, 'recibos-monitoramento.zip');
        },
        async baixarRelatorio(item) {
            try {
                const listaFormatada = this.formatarParaRelatorio([item]);
                await downloadRelatorioMonitoramentos(listaFormatada);
            } catch (error) {
                console.error('Erro ao baixar relatório:', error);
                this.$message.error('Erro ao baixar o relatório do processo.');
            }
        },
        formatarCpfCnpjTexto(valor, tipo) {
            if (!valor) return '';
            const digits = valor.replace(/\D/g, '');
            if (tipo === 'PF' && digits.length === 11) {
                return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (tipo === 'PJ' && digits.length === 14) {
                return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
            return valor;
        },
        formatarDominiosTexto(dominios) {
            if (!Array.isArray(dominios) || !dominios.length) return '';
            return dominios
                .map((dom) => `- ${this.formatarNome(dom.nome)} (${this.formatarCpfCnpjTexto(dom.cpfCnpj, dom.tipoPessoa)})`)
                .join('\n');
        },
        formatarParaRelatorio(lista) {
            return lista.map((processo) => ({
                ...processo,
                dominiosFormatados: this.formatarDominiosTexto(processo.dominio),
                statusMonitoramento: this.formatarStatus(processo.statusMonitoramento),
                statusValidacao: this.formatarStatusValidacao(processo.statusValidacao),
            }));
        },
        expandirProcessosPorDominio(lista) {
            const novaLista = [];

            lista.forEach((processo) => {
                const dominios = Array.isArray(processo.dominio) ? processo.dominio : [];

                if (dominios.length > 0) {
                    dominios.forEach((dom) => {
                        novaLista.push({
                            ...processo,
                            nomeProprietario: dom.nome,
                            cpfcnpjProprietario: dom.cpfCnpj,
                            tipoUsuario: dom.tipoPessoa,
                        });
                    });
                } else {
                    novaLista.push({ ...processo });
                }
            });

            return novaLista;
        },
        async baixarTodosRelatorios() {
            if (!this.selecionadosParaAcao.length) {
                this.$message.warning('Nenhum processo selecionado para download.');
                return;
            }

            try {
                const listaFormatada = this.formatarParaRelatorio(this.selecionadosParaAcao);

                await downloadRelatorioMonitoramentos(listaFormatada);
            } catch (error) {
                console.error('Erro ao baixar todos os relatórios:', error);
                this.$message.error('Erro ao baixar os relatórios.');
            }
        },
        async buscarMunicipiosDisponiveis(regional) {

            if (!regional) {
                this.municipiosFiltrados = [...this.municipiosAll];
                return;
            }

            this.municipiosFiltrados = await listarMunicipios(regional);
        },
        async buscarRegionaisDisponiveis(municipio) {

            if (!municipio) {
                this.regionaisFiltradas = [...this.regionaisAll];
                return;
            }

            this.regionaisFiltradas = await obterRegionais(municipio);
        },
        abrirModalNotificacao(item) {
            this.monitoramentoParaNotificar = item;
            this.showModalNotificacao = true;
        },
        fecharModalNotificacao() {
            this.showModalNotificacao = false;
            this.monitoramentoParaNotificar = null;
        },
        confirmarEnvioNotificacao() {
            if (!this.monitoramentoParaNotificar) return;

            this.enviandoNotificacao = true;

            enviarNotificacao(this.monitoramentoParaNotificar.idMonitoramento, this.monitoramentoParaNotificar.numeroDoCAR)
                .then(() => {
                    this.$toast({
                        showClose: true,
                        message: 'Notificação enviada com sucesso.',
                        type: 'success',
                    });
                    this.fecharModalNotificacao();
                })
                .catch((error) => {
                    console.error('Erro ao enviar notificação:', error);
                    this.$message.error('Erro ao enviar notificação.');
                })
                .finally(() => {
                    this.enviandoNotificacao = false;
                });
        },

        async baixarPdfNotificacao() {
            if (!this.monitoramentoParaNotificar) return;

            this.baixandoPdfNotificacao = true;

            try {
                await baixarPdfNotificacaoVencida(
                    this.monitoramentoParaNotificar.idMonitoramento, this.monitoramentoParaNotificar.numeroNotificacao
                );


            } catch (error) {
                console.error("Erro ao baixar PDF da notificação:", error);
                this.$message.error("Erro ao baixar o PDF da notificação.");
            } finally {
                this.baixandoPdfNotificacao = false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@use '@/styles/variaveis' as *;

.btn-relatorio {
    background-color: #4caf50; /* azul padrão */
    color: white;
    border: none;
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.btn-relatorio:hover:not(:disabled) {
    background-color: #4caf50; /* azul mais escuro no hover */
}

.btn-desabilitado {
    background-color: #cccccc !important; /* cinza claro */
    color: #666666 !important; /* texto cinza escuro */
    cursor: not-allowed !important;
}

.titulo-tabela {
    span {
        display: block;
        font-size: 12px;
        font-weight: bold;
        padding-bottom: 5px;
    }
}

.botao-acoes {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}

.botao-acoes i {
    font-size: 18px;
}

.resposta-container {
    display: flex;
    align-items: center;
}

.resposta-container span {
    font-size: 12px;
    font-weight: normal;
}

.text-left {
    text-align: left;
}

.mapa-container {
    padding: 20px 0 20px 0;
}

.descricao-foto {
    color: $success_color;
    font-style: italic;
    font-size: 12px;
}

.foto-preview {
    margin-top: 6px;
}

.foto-parcela {
    max-width: 100%;
    max-height: 300px;
    border-radius: 4px;
    border: 1px solid #ddd;
    display: block;
}

.foto-preview-loading {
    margin-top: 6px;
    font-style: italic;
    color: #888;
    font-size: 12px;
}

.titulo-arquivo-foto {
    vertical-align: top;
}

.listagem-fotos-scroll {
    max-height: 45vh;
    overflow-y: auto;
    margin-top: 12px;
}

.listagem-fotos-scroll::-webkit-scrollbar {
    width: 8px;
}
.listagem-fotos-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.listagem-fotos-scroll::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}
.listagem-fotos-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.barra-verde {
    border: 3px solid #67c23a;
    background-color: #67c23a;
    border-radius: 5px 5px 0px 0px;
    cursor: pointer;
}

.barra-verde h2 {
    color: #fff;
    padding: 0px 20px;
    font-size: 11px;
    font-weight: 600;
}

.card-container {
    border: 1px solid #00000037;
    border-radius: 0px 0px 5px 5px;
    height: 45vh;
    margin-top: 0px;
}

@media (max-width: 1423px) {
    .card-container {
        height: 80vh;
    }
}

.form-container {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 50px;
    padding: 0px 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 400px;
}

.label-campo {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 12px;
    margin-top: -30px;
}

.input-campo {
    padding: 8px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 15px;
}

.select-campo {
    padding: 8px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 50%;
    height: 35px;
}

.form-group-cpf {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}

.label-campo-cpf {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}

.input-campo-cpf {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 15px;
}

/* Data Inicial */
.form-group-data-inicial {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-data-inicial {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
    margin-left: 100px;
}
.input-campo-data-inicial {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 15px;
    width: 50%;
    margin-left: 100px;
}

/* Data Final */
.form-group-data-final {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-data-final {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.input-campo-data-final {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 15px;
    width: 50%;
}

/* CPF */
.form-group-cpf {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-cpf {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.input-campo-cpf {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

/* Data Inicial */
.form-group-data-inicial {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-data-inicial {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.input-campo-data-inicial {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

/* Data Final */
.form-group-data-final {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-data-final {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.input-campo-data-final {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

/* Nível de Adequação */
.form-group-nivel-monitoramento {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-nivel-monitoramento {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.select-campo-nivel-monitoramento {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 40px;
}

/* Status do Monitoramento */
.form-group-status-monitoramento {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-status-monitoramento {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.select-campo-status-monitoramento {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 40px;
}

/* Avaliação Geral */
.form-group-avaliacao-geral {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
}
.label-campo-avaliacao-geral {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.select-campo-avaliacao-geral {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 40px;
}

/* Município */
.form-group-municipio {
    display: flex;
    flex-direction: column;
    flex: 1;
}
.label-campo-municipio {
    margin-bottom: 6px;
    font-weight: bold;
    font-size: 12px;
}
.select-campo-municipio {
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 40px;
    width: 20%;
}

.botoes {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 0px;
    padding: 30px;
}

.botoes button {
    background-color: #fff;
    color: #000000;
    height: 35px;
    width: 120px;
    cursor: pointer;
    font-weight: 600;
}

.botao-limpar button {
    transition: 0.3s;
}

.botao-limpar button:hover {
    background-color: #d7d7d7;
}

.botao-pesquisar button {
    background-color: #59b52b;
    color: #fff;
    transition: 0.3s;
}

.botao-pesquisar button:hover {
    background-color: #45a714;
}

.botoes-topo {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: -20px;
    padding: 0px 30px;
}

.botao-recibo button,
.botao-exportar button {
    background-color: #59b52b;
    color: #fff;
    font-weight: 600;
    height: 35px;
    width: 200px;
    cursor: pointer;
    transition: 0.3s;
}

.botao-recibo button:hover,
.botao-exportar button:hover {
    background-color: #45a714;
}

.topo-tabela {
    margin-top: 30px;
}

.topo-tabela h2 {
    font-size: 12px;
}

.tabela-cadastro {
    padding: 10px; /* Menos padding para deixar o espaço menor */
    width: 100%;
    height: auto;
}

.tabela {
    width: 100%; /* Garante que a tabela ocupe toda a largura disponível */
    max-width: 1500px; /* Limita a largura máxima da tabela */
    border-collapse: collapse;
}

th,
td {
    padding: 5px 8px; /* Menos padding para deixar as células mais compactas */
    min-width: 50px; /* Diminui a largura mínima das colunas */
    font-size: 12px; /* Diminui o tamanho da fonte */
}

th {
    background-color: #ffffff;
    color: rgb(0, 0, 0);
    border: 1px solid #00000037;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
}

th:nth-child(1),
td:nth-child(1) {
    width: 10%; /* Coluna "Ano" mais estreita */
}

th:nth-child(2),
td:nth-child(2) {
    width: 10%; /* Coluna "Lei" ajustada para ocupar um tamanho razoável */
}

th:nth-child(3),
td:nth-child(3) {
    width: 15%; /* Coluna "Ações" menor */
}

th:nth-child(4),
td:nth-child(4) {
    width: 10%; /* Coluna "Ações" menor */
}

th:nth-child(5),
td:nth-child(5) {
    width: 10%; /* Coluna "Ações" menor */
}

th:nth-child(6),
td:nth-child(6) {
    width: 15%; /* Coluna "Ações" menor */
}
th:nth-child(7),
td:nth-child(7) {
    width: 10%; /* Coluna "Ações" menor */
}
th:nth-child(8),
td:nth-child(8) {
    width: 25%; /* Coluna "Ações" menor */
}

td {
    line-height: 3; /* Ajusta o espaçamento entre as linhas das células */
    background-color: #fff;
    border: 1px solid #00000037;
}

td i {
    font-size: 16px; /* Ajusta o tamanho dos ícones para serem menores */
    display: block;
    margin: 0 auto; /* Centraliza os ícones na coluna */
    cursor: pointer;
}
.tabela tr:nth-child(odd) {
    background-color: #f2f2f2; /* Cor de fundo para linhas ímpares (cinza claro) */
}

.tabela tr:nth-child(even) {
    background-color: white; /* Cor de fundo para linhas pares (branco) */
}

.tabela .colspan-titulo {
    font-size: 12px; /* Diminui o tamanho da fonte do título */
    font-weight: bold;
    background-color: #ffffff;
    color: white;
    padding: 8px 12px; /* Menos padding */
}

.tabela .colspan-titulo span {
    color: white;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.table th,
.table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.badge-validacao {
    background-color: #c7a17a;
    padding: 4px 8px;
    border-radius: 8px;
    color: white;
}

.badge-assinatura {
    background-color: #e26d2c;
    padding: 4px 8px;
    border-radius: 8px;
    color: white;
}

.badge-atendimento {
    background-color: #f48c06;
    padding: 4px 8px;
    border-radius: 8px;
    color: white;
}

.badge-vinculacao {
    background-color: #ffcd3c;
    padding: 4px 8px;
    border-radius: 8px;
    color: white;
}

.badge-analise {
    background-color: #4caf50;
    padding: 4px 8px;
    border-radius: 8px;
    color: white;
}

.pagination {
    margin-top: 10px;
    display: flex;
    gap: 5px;
}

.pagination button {
    background: #eee;
    border: none;
    padding: 5px 10px;
}

.pagination .active {
    background: #4caf50;
    color: white;
}

.exibindo {
    margin-top: 5px;
    font-size: 14px;
}

.btn-monitoramento {
    background-color: #45a714;
    height: 30px;
    color: #fff;
    font-weight: 600;
    border: none;
    margin-right: 10px;
    cursor: pointer;
    border-radius: 5px;
}

.btn-relatorio {
    background-color: #45a714;
    height: 30px;
    color: #fff;
    font-weight: 600;
    border: none;
    cursor: pointer;
    border-radius: 5px;
}

.modal-body-scroll {
    max-height: 60vh; // ou qualquer altura desejada
    overflow-y: auto;
    padding: 20px;
}

.modal-body-scroll::-webkit-scrollbar {
    width: 8px;
}
.modal-body-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.modal-body-scroll::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}
.modal-body-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.bloco-processo {
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

.bloco-processo h3 {
    margin-bottom: 10px;
    color: #007bff;
}

.btn-download-individual,
.btn-download-todos {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 8px 12px;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.btn-download-individual:hover,
.btn-download-todos:hover {
    background-color: #4caf50;
}

.footer-download {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.abas-container {
    display: flex !important;
    justify-content: center !important;
}

.modal-notificacao-body {
    padding: 16px 0;
}

.alerta-info {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background-color: #f5f5f5;
    border-left: 4px solid #2f8fd6;
    border-radius: 4px;
    padding: 14px 16px;
}

.alerta-icon {
    color: #2f8fd6;
    font-size: 18px;
    margin-top: 1px;
    flex-shrink: 0;
}

.alerta-texto {
    font-size: 13px;
    color: #333;
    line-height: 1.5;
}

.footer-notificacao {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 150px;
    margin-top: 20px;
}

.campo-ultima-notificacao {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
    padding: 12px 16px;
    background-color: #f5f5f5;
    border-radius: 4px;
}

.info-ultima-notificacao {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.label-ultima-notificacao {
    font-size: 12px;
    font-weight: bold;
    color: #333;
}

.data-ultima-notificacao {
    font-size: 13px;
    color: #555;
}

.btn-download-pdf-notificacao {
    background-color: $primary-color;;
    color: #fff;
    font-weight: 600;
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: 0.3s;
}

.btn-download-pdf-notificacao:hover:not(:disabled) {
    background-color: darken($primary-color, 10%);
}
</style>
